// Outbound article links carry ?utm_source=election so Oriental Daily's own
// analytics attribute the traffic back to this microsite — the same tag
// article_with_gallery.php / article_tag.php bake into the URLs they build.
// Editor-pasted links (seat pins) arrive untagged, so tag them at render time.
export const withUtm = (url, source = 'election') => {
  if (!url) return url;
  try {
    const u = new URL(url, window.location.origin);
    // Never overwrite a tag the editor (or the CMS) already put on the link.
    if (!u.searchParams.has('utm_source')) u.searchParams.set('utm_source', source);
    return u.toString();
  } catch {
    return url; // unparseable — leave the editor's link exactly as pasted
  }
};
